import { render, staticRenderFns } from "./newClass.vue?vue&type=template&id=7caed95e&scoped=true&class=m-0"
import script from "./newClass.vue?vue&type=script&lang=js"
export * from "./newClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caed95e",
  null
  
)

export default component.exports